var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.visible)?_c('v-btn',{staticClass:"mx-1 renewal-button",attrs:{"small":"","rounded":"","color":"success","loading":_vm.loading},on:{"click":_vm.onClick}},[_c('v-icon',{attrs:{"left":"","small":""}},[_vm._v("mdi-autorenew")]),_vm._v(" %10 İndirimle Yenile ")],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }